export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/linkedin.8924e4f.svg";